import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Row, Col } from "react-bootstrap";
import {
  getConsultationById,
  addOrUpdatePrescription,
  NoPrescription
} from "../../actions/consultationAction";
import { getReasonTemplates } from "../../actions/reasonTemplateAction";
import moment from "moment-timezone";

import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { FaEye, FaUser, FaMapMarkerAlt, FaBuilding, FaCalendarAlt, FaWeight, FaRulerVertical, FaDollarSign, FaTag, FaHashtag } from "react-icons/fa";
import { IoWarningOutline, IoArrowBack } from "react-icons/io5";
import { Link } from "react-router-dom";

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { ENV } from "../../config/config";
import { Bars } from "react-loader-spinner";
import locationBtn from "../../assets/images/location-icon.svg";
import calendarBtn from "../../assets/images/calendar-icon.svg";
import ScaleBtn from "../../assets/images/scale-icon.svg";
import discountBtn from "../../assets/images/promo-discount.svg";
import BuildingBtn from "../../assets/images/building-icon.svg";
import zipBtn from "../../assets/images/zip-code-icon.svg";
import dollarBtn from "../../assets/images/dollar-icon.svg";
import weightBtn from "../../assets/images/weight-icon.svg";
import profileBtn from "../../assets/images/profile-icon.svg";


const sendPrescriptionSchema = Yup.object().shape({
  pharmacyName: Yup.string().trim().required("Pharmacy name field is required"),
  doctorId: Yup.string().trim().required("Doctor is required"),
  pharmacyAddress: Yup.string()
    .trim()
    .required("Pharmacy address field is required"),
  prescription: Yup.string()
    .trim()
    .required("Pharmacy prescription field is required"),
});


const sendNoPrescriptionSchema = Yup.object().shape({
  pharmacyName: Yup.string().trim().required("Pharmacy name field is required"),
  doctorId: Yup.string().trim().required("Doctor is required"),
  pharmacyAddress: Yup.string()
    .trim()
    .required("Pharmacy address field is required"),

});

export default function ViewConsultation() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [consultationData, setConsultationData] = useState({});

  const [formfield, setFormfieldData] = useState({});
  const [initialValue, setInitialValue] = useState({});
  const [show, setShow] = useState(false);
  const [disable, setDisable] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [showAlertNotSent, setShowAlertNotSent] = useState(false);

  const [showNotSent, setShowNotSent] = useState(false);

  const [loader, setLoader] = useState(true);
  const [doctorData, setDoctorData] = useState([]);
  const [reasonTemplates, setReasonTemplates] = useState([]);
  const [selectedReason, setSelectedReason] = useState(null);

  const [sendloader, setSendloader] = useState(false);
  const handleClose = () => setShow(false);
  const handleCloseShowNotsent = () => setShowNotSent(false);

  // const handleShow = () => setShow(true);



const handleShow = () => {
  if (consultationData.isPaid === "unpaid") {
    setShowAlert(true);
  } else {
    setShow(true);
  }
};

const handleConfirm = (confirmed) => {
  setShowAlert(false); 
  setShow(confirmed);  
};

// Handler functions
const handleShowNotsent = () => {
  if (consultationData.isPaid == "unpaid") {
    setShowAlertNotSent(true);
  } else {
    setShowNotSent(true);
  }
};

const handleConfirmNotSent = (confirmed) => {
  setShowAlertNotSent(false); 
  setShowNotSent(confirmed);  
};


  const { admin } = useSelector((state) => state.admin);

  const convertUnderScoreToSpace = (str) => {
    var text = str.replace(/_/g, " ");
    return text.replace(/nbsp/g, " ");
  };

  const setFilePath = (files) => {
    return `${ENV.serverUrl}/public/uploads${files}`;
  };


const getMailContent = (selectedReason) => {
  const baseContent = "<p>Thank you for choosing PulsecareMD. After a thorough review of your medical information, the provider has determined that a prescription will not be issued at this time based on their clinical judgment.</p>";
  
  let reasonContent = "";
  if (selectedReason && selectedReason.description) {
    reasonContent = `<p><strong>Reason:</strong> ${selectedReason.description}</p>`;
  }
  
  const endContent = "<p>Please understand that this decision is made with your health and safety in mind. If you have any questions or feel your condition requires further evaluation, we recommend seeking in-person care with a local healthcare provider.</p>&nbsp;<p>Thank you for your understanding.</p>";
  
  return baseContent + reasonContent + endContent;
};

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValue,
    // validationSchema: sendPrescriptionSchema,
    validationSchema: disable ? sendNoPrescriptionSchema : sendPrescriptionSchema,

  
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSendloader(true); 
        let res
        if(showNotSent){
          values.noPrescription=true;
         res = await NoPrescription(
          consultationData?.user,
          id,
          values
        );
         }
         else{
          res = await addOrUpdatePrescription(
            consultationData?.user,
            id,
            values
          );
         }
         
        if (res.data.success) {
          navigate("/consultations");
          toast.success(res.data.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        setSendloader(false);
        setSubmitting(false); 
      }
    },
  });


  const DOBCOnverter = (dateString) => {
    return moment.utc(dateString).format("MM-DD-YYYY");
  };

  const getAgeFromDate = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var ageDiff = today.getTime() - birthDate.getTime();
    var ageDate = new Date(ageDiff);
    var age = Math.abs(ageDate.getUTCFullYear() - 1970);
    return age;
  };

  const getAllReasonTemplates = async () => {
    try {
      let res = await getReasonTemplates();
      if (res?.data?.data) {
        // Filter out inactive reason templates (status: false)
        const activeReasonTemplates = res.data.data.filter(reason => reason.status === true);
        setReasonTemplates(activeReasonTemplates);
      }
    } catch (error) {
      console.error("Error fetching reason templates:", error);
    }
  };

  const handleReasonChange = (reasonId) => {
    const selectedReasonTemplate = reasonTemplates.find(reason => reason._id === reasonId);
    setSelectedReason(selectedReasonTemplate);
  };

  useEffect(() => {
    const getConsultation = async () => {
            let res = await getConsultationById(id);
      if (res?.data?.data) {
        const updatedPharmacy = res?.data?.data?.updatedPharmacy;
        const pharmacyData = res?.data?.data;
        const data = {
          pharmacyName: updatedPharmacy
            ? `${updatedPharmacy.pharmacyName} `
            : `${pharmacyData.pharmacyName} `,
          pharmacyAddress: updatedPharmacy
            ? `${updatedPharmacy.pharmacyAddress} ${updatedPharmacy.pharmacyCity} ${updatedPharmacy.state?.title} ${updatedPharmacy.pharmacyZip}`
            : `${pharmacyData.pharmacyAddress} ${pharmacyData.pharmacyCity} ${pharmacyData.state?.title} ${pharmacyData.pharmacyZip}`,

          prescription: res?.data?.data.prescription
            ? res?.data?.data.prescription.prescription
            : res?.data?.data.template?.content || setDisable(true),
            doctorId:res?.data?.data?.doctorId
        };
        
        setInitialValue(data);
        setDoctorData(res?.data?.doctorData)
        setFormfieldData(JSON.parse(res.data.data?.formField));
        setConsultationData(res?.data?.data);
      }
      setLoader(false);
    };
    getConsultation();
    getAllReasonTemplates();
  }, [id]);

  // Effect to update CKEditor content when reason changes
  useEffect(() => {
    if (showNotSent) {
      formik.setFieldValue("prescription", getMailContent(selectedReason));
    }
  }, [selectedReason, showNotSent]);

  const downloadImage = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "image.jpg";
      a.style.display = "none";

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading image:", error);
    }
  };


  return (
    <>
      {show && (
        <Modal
          className="send-Prescription-modal custom-prescription-modal"
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold w-100 text-center">
              Prescription Form
            </Modal.Title>
          </Modal.Header>
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body>
              <Row>
                <Col>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      Pharmacy Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="pharmacyName"
                      placeholder="Enter pharmacy name"
                      value={formik.values?.pharmacyName}
                      readOnly
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Form.Group>
                  {formik.touched.pharmacyName && formik.errors.pharmacyName ? (
                    <span
                      className={formik.errors.pharmacyName ? `` : `d-none`}
                    >
                      <label className="pl-1 text-danger">
                        {formik.errors.pharmacyName}
                      </label>
                    </span>
                  ) : null}
                </Col>
                <Col>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      Pharmacy Location <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="pharmacyAddress"
                      placeholder="Enter pharmacy location"
                      value={formik.values?.pharmacyAddress}
                      readOnly
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Form.Group>
                  {formik.touched.pharmacyName && formik.errors.pharmacyName ? (
                    <span
                      className={formik.errors.pharmacyName ? `` : `d-none`}
                    >
                      <label className="pl-1 text-danger">
                        {formik.errors.pharmacyName}
                      </label>
                    </span>
                  ) : null}
                </Col>
                <Col>
              <Form.Group className="mb-1" controlId="formDoctorId">
                <Form.Label>
                Prescribed by  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="select"
                  name="doctorId" 
                  value={formik.values?.doctorId || ''}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Select Prescriber</option>
                  {doctorData?.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.username}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              {formik.touched.doctorId && formik.errors.doctorId ? (
                <span className={formik.errors.doctorId ? `` : `d-none`}>
                  <label className="pl-1 text-danger">
                    {formik.errors.doctorId}
                  </label>
                </span>
              ) : null}
              </Col>
              </Row>
              <Row>
                <Col>
                <div className="editor-wrapper">
                  <Form.Label>
                    Content <span className="text-danger">*</span>
                  </Form.Label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={
                      formik.values.prescription
                        ? formik.values.prescription
                        : ""
                    }
                    content={
                      formik.values.prescription
                        ? formik.values.prescription
                        : ""
                    }
                    onChange={(event, editor) =>
                      formik.setFieldValue("prescription", editor.getData())
                    }
                  />
                  {formik.touched.prescription && formik.errors.prescription ? (
                    <span
                      className={formik.errors.prescription ? `` : `d-none`}
                    >
                      <label className="pl-1 text-danger">
                        {formik.errors.prescription}
                      </label>
                    </span>
                  ) : null}
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              {sendloader ? (
                <Button
                  className="btn-light-blue auth-btn mb-4 disabled"
                  disabled
                >
                  <Bars
                    height="33"
                    width="33"
                    color="#fff"
                    ariaLabel="bars-loading"
                    visible={true}
                    wrapperClass="bars-wrapper-loader"
                  />
                </Button>
              ) : (
                <Button
                  className="float-sm-right btn-filled d-flex align-items-center btn btn-primary"
                  type="submit"
                >
                  Send
                </Button>
              )}
            </Modal.Footer>
          </Form>
        </Modal>
      )}

   {showNotSent && (
        <Modal
          className="send-Prescription-modal custom-prescription-modal"
          show={showNotSent}
          onHide={handleCloseShowNotsent}
        >
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold w-100 text-center">
             NO Prescription Form
            </Modal.Title>
          </Modal.Header>
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body>
              <Row>
                <Col>
                 
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>
                        Pharmacy Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="pharmacyName"
                        placeholder="Enter pharmacy name"
                        value={formik.values?.pharmacyName}
                        readOnly
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Form.Group>
                    {formik.touched.pharmacyName && formik.errors.pharmacyName ? (
                      <span
                        className={formik.errors.pharmacyName ? `` : `d-none`}
                      >
                        <label className="pl-1 text-danger">
                          {formik.errors.pharmacyName}
                        </label>
                      </span>
                    ) : null}
                  
                </Col>
                <Col>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      Pharmacy Location <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="pharmacyAddress"
                      placeholder="Enter pharmacy location"
                      value={formik.values?.pharmacyAddress}
                      readOnly
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Form.Group>
                  {formik.touched.pharmacyName && formik.errors.pharmacyName ? (
                    <span
                      className={formik.errors.pharmacyName ? `` : `d-none`}
                    >
                      <label className="pl-1 text-danger">
                        {formik.errors.pharmacyName}
                      </label>
                    </span>
                  ) : null}
                </Col>
                <Col>
              <Form.Group className="mb-1" controlId="formDoctorId">
                <Form.Label>
                Prescribed by  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="select"
                  name="doctorId" 
                  value={formik.values?.doctorId || ''}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Select Prescriber</option>
                  {doctorData?.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.username}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
               {formik.touched.doctorId && formik.errors.doctorId ? (
                 <span className={formik.errors.doctorId ? `` : `d-none`}>
                   <label className="pl-1 text-danger">
                     {formik.errors.doctorId}
                   </label>
                 </span>
               ) : null}
               </Col>
               </Row>
               <Row>
                 <Col>
                   <Form.Group className="mb-1" controlId="formReasonId">
                     <Form.Label>
                       Reason
                     </Form.Label>
                     <Form.Control
                       as="select"
                       name="reasonId"
                       value={selectedReason?._id || ''}
                       onChange={(e) => handleReasonChange(e.target.value)}
                     >
                       <option value="">Select Reason (Optional)</option>
                       {reasonTemplates?.map((reason) => (
                         <option key={reason._id} value={reason._id}>
                           {reason.title}
                         </option>
                       ))}
                     </Form.Control>
                   </Form.Group>
                 </Col>
               </Row>
               <Row>
                 <Col>
                 <div className="editor-wrapper">
                     <Form.Label>
                       Content <span className="text-danger">*</span>
                     </Form.Label>
                     <CKEditor
                       editor={ClassicEditor}
                       data={getMailContent(selectedReason)}
                       content={getMailContent(selectedReason)}
                       onChange={(event, editor) =>
                         formik.setFieldValue("prescription", editor.getData())
                       }
                    />
                    {formik.touched.prescription && formik.errors.prescription ? (
                      <span
                        className={formik.errors.prescription ? `` : `d-none`}
                      >
                        <label className="pl-1 text-danger">
                          {formik.errors.prescription}
                        </label>
                      </span>
                    ) : null}
                  </div>  

                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              {sendloader ? (
                <Button
                  className="btn-light-blue auth-btn mb-4 disabled"
                  disabled
                >
                  <Bars
                    height="33"
                    width="33"
                    color="#fff"
                    ariaLabel="bars-loading"
                    visible={true}
                    wrapperClass="bars-wrapper-loader"
                  />
                </Button>
              ) : (
                <Button
                  className="float-sm-right btn-filled d-flex align-items-center btn btn-primary"
                  type="submit"
                >
                  Send
                </Button>
              )}
            </Modal.Footer>
          </Form>
        </Modal>
      )}
{/******************************************** */}
{showAlert && (
  <Modal
    className="send-Prescription-modal warning-modal custom-prescription-modal"
    show={showAlert}
    onHide={() => setShowAlert(false)}
  >
    <div className="alert alert-warning">
    <button
        type="button"
        className="close"
        onClick={() => setShowAlert(false)}
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>  
    <div className="warning-modal-body show" role="alert">
      <IoWarningOutline />
      <h2>Warning!</h2>
      <p>Consultation is not paid. Do you want to proceed?</p>
      <button
        className="btn btn-success btn-sm mx-2"
        onClick={() => handleConfirm(true)}
      >
        Yes
      </button>
      <button
        className="btn btn-danger btn-sm mx-2"
        onClick={() => handleConfirm(false)}
      >
        No
      </button>
      
    </div>
  </Modal>
)}

{showAlertNotSent && (
  <Modal
    className="send-Prescription-modal warning-modal custom-prescription-modal"
    show={showAlertNotSent}
    onHide={() => setShowAlertNotSent(false)}
  >
    <div className="alert alert-warning">
    <button
        type="button"
        className="close"
        onClick={() => setShowAlertNotSent(false)}
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>  
    <div className="warning-modal-body show" role="alert">
      <IoWarningOutline />
      <h2>Warning!</h2>
      <p>Consultation is not paid. Do you want to proceed for no prescription mail?</p>
      <button
        className="btn btn-success btn-sm mx-2"
        onClick={() => handleConfirmNotSent(true)}
      >
        Yes
      </button>
      <button
        className="btn btn-danger btn-sm mx-2"
        onClick={() => handleConfirmNotSent(false)}
      >
        No
      </button>
      
    </div>
  </Modal>
)}

{/************************************************ */}

      {loader ? (
        <FullPageLoader></FullPageLoader>
      ) : (
        <>
          <div className="dashboard-consultation-wrapper">
            <div className="d-flex align-items-center mb-4">
              <Link
                className="generic-back-btn btn-filled align-items-center btn btn-primary mr-3 no-position filter-reset-btn"
                to={
                  localStorage?.getItem("prevPath")
                    ? `${localStorage?.getItem("prevPath")}`
                    : ""
                }
              >
                <IoArrowBack className="mr-2" />
                Back
              </Link>
              <h2 className="mb-0 consultation-details-header">Consultation Detail - #{id}</h2>
            </div>
            {consultationData?.discount && (
              <>
                <div className="table-heading position-relative mb-4">
                  <h5 className="mb-0">Partner Form</h5>
                  <div className="heading-underline"></div>
                </div>
                <Row>
                  <Col md="12">
                    <Link
                      className="float-sm-left btn-filled d-flex align-items-center link-btn view-partner-form "
                      target="_blank"
                      to={`/view-consultation/${consultationData?.discount?.userAppointmentType}`}
                    >
                      <span className="add-icon mr-2">
                        <FaEye />
                      </span>
                    </Link>
                  </Col>
                </Row>
              </>
            )}
            <div className="patient-consultation-layout">
            <div className="table-heading position-relative mb-5">
              <h5 className="mb-0">About Patient</h5>
              <div className="heading-underline"></div>
            </div>
            
            <div className="patient-info-card ">
              {/* Patient Summary Banner */}
              <div className="patient-summary-banner">
                <div className="d-flex align-items-md-center align-items-start flex-column flex-md-row">
                  <div className="patient-icon-wrapper">
                   <img src={profileBtn} alt="Profile Icon" />
                  </div>
                  <div className="patient-summary-content">
                    <h3 className="patient-name mb-3">
                      {consultationData?.firstName + " " + consultationData?.lastName}
                    </h3>
                    <Row className="patient-summary-details">
                      <Col >
                        <span className="detail-label">Age: </span>
                        <span className="detail-value">{getAgeFromDate(consultationData?.dateOfBirth)} Year</span>
                      </Col>
                      <Col >
                        <span className="detail-label">Gender: </span>
                        <span className="detail-value">{consultationData?.gender}</span>
                      </Col>
                      <Col>
                        <span className="detail-label">Phone: </span>
                        <span className="detail-value">{consultationData?.phone}</span>
                      </Col>
                      <Col>
                        <span className="detail-label">Email: </span>
                        <span className="detail-value">{consultationData?.email}</span>
                      </Col>
                      <Col >
                        <span className="detail-label">Condition: </span>
                        <span className="condition-badge">
                          {consultationData?.diseaseName}
                        </span>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

              {/* Detailed Patient Information */}
              <div className="patient-details-section">
                <Row>
                  <Col md={6} className="mb-3">
                    <div className="detail-item">
                      <div className="detail-icon">
                        <img src={locationBtn} alt="Location Icon" />
                      </div>
                      <div className="detail-text">
                        <span className="detail-label">Address: </span>
                        <span className="detail-value">{consultationData?.address}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="detail-item">
                      <div className="detail-icon">
                        <img src={BuildingBtn} alt="Building Icon" />
                      </div>
                      <div className="detail-text">
                        <span className="detail-label">City: </span>
                        <span className="detail-value">{consultationData?.city}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="detail-item">
                      <div className="detail-icon">
                        <img src={locationBtn} alt="Location Icon" />
                      </div>
                      <div className="detail-text">
                        <span className="detail-label">State: </span>
                        <span className="detail-value">{consultationData?.state?.title}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="detail-item">
                      <div className="detail-icon">
                        <img src={zipBtn} alt="Zip Code Icon" />
                      </div>
                      <div className="detail-text">
                        <span className="detail-label">Zip Code: </span>
                        <span className="detail-value">{consultationData?.zip}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="detail-item">
                      <div className="detail-icon">
                        <img src={calendarBtn} alt="Calendar Icon" />
                      </div>
                      <div className="detail-text">
                        <span className="detail-label">DOB: </span>
                        <span className="detail-value">{DOBCOnverter(consultationData?.dateOfBirth)}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="detail-item">
                      <div className="detail-icon">
                        <img src={weightBtn} alt="Weight Icon" />
                      </div>
                      <div className="detail-text">
                        <span className="detail-label">Weight: </span>
                        <span className="detail-value">{consultationData?.weight}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="detail-item">
                      <div className="detail-icon">
                        <img src={ScaleBtn} alt="Height Icon" />
                      </div>
                      <div className="detail-text">
                        <span className="detail-label">Height: </span>
                        <span className="detail-value">{consultationData?.height}</span>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="detail-item">
                      <div className="detail-icon">
                        <img src={dollarBtn} alt="Dollar Icon" />
                      </div>
                      <div className="detail-text">
                        <span className="detail-label">Actual Price: </span>
                        <span className="detail-value">
                          $
                          {!consultationData?.actual_price ||

                          consultationData?.actual_price == 0
                            ? consultationData?.actualPrice?.price || consultationData?.presActualPrice?.price
                            : consultationData?.actual_price ?? consultationData?.actualPrice?.price}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="detail-item">
                      <div className="detail-icon">
                        <img src={discountBtn} alt="Discount Icon" />
                      </div>
                      <div className="detail-text">
                        <span className="detail-label">After Promo Discount: </span>
                        <span className="detail-value">
                          {consultationData?.promoCode?.discountValue ? "$" : ""}
                          {consultationData?.promoCode?.discountValue || "No Discount"}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="detail-item">
                      <div className="detail-icon">
                         <img src={discountBtn} alt="Discount Icon" />
                      </div>
                      <div className="detail-text">
                        <span className="detail-label">After Partner Discount: </span>
                        <span className="detail-value">
                          {consultationData?.discount?.discount?.toFixed(0, 2) || "No Discount"}
                          {consultationData?.discount?.discount ? "%" : ""}

                        </span>
                      </div>
                    </div>
                  </Col>
                  {(() => {
                    const opt = consultationData?.expediteOption;
                    const optionPriceNum = Number(opt?.price);
                    if (
                      !opt ||
                      !(optionPriceNum > 0 && !Number.isNaN(optionPriceNum))
                    )
                      return null;

                    const addonTimeZone =
                      consultationData?.timeZone ?? opt?.timeZone;
                    const addonFeeRaw =
                      consultationData?.expediteFee != null &&
                      consultationData?.expediteFee !== ""
                        ? consultationData.expediteFee
                        : opt?.expediteFee != null && opt?.expediteFee !== ""
                          ? opt.expediteFee
                          : opt?.price;
                    const addonFeeNum = Number(addonFeeRaw);

                    return (
                    <Col md={6} className="mb-3">
                      <div className="detail-item">
                        <div className="detail-icon">
                          <img src={dollarBtn} alt="Expedite Icon" />
                        </div>
                        <div className="detail-text">
                        <div className="detail-value-expedite">
                          <span className="detail-label">Add-on: </span>
                        <div>
                          <span className="detail-value">
                          <strong>
                            {addonTimeZone && ` (${addonTimeZone})`}
                           <span className="text-success "> {addonFeeNum > 0 && !Number.isNaN(addonFeeNum) && ` - Fee: $${addonFeeRaw}`}</span></strong>
                          </span>

                          </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    );
                  })()}
                </Row>
              </div>
            </div>
            </div>
            <div className="patient-consultation-layout mt-3">
            <div className="table-heading position-relative mb-5 ">
              <h5 className="mb-0">Medical Info</h5>
              <div className="heading-underline"></div>
            </div>
            <div className="table-responsive medical-custom-info">
              <Table striped className="consultation-table mb-4">
                <tbody>
                  {Object.keys(formfield)?.map((key, index) => {
                    return (
                      <>
                        <tr key={index}>
                          <th>Q. {convertUnderScoreToSpace(key)}</th>
                          {typeof formfield[key] === "object" ? (
                            <td>
                              {formfield[key]?.map((k, i) => {
                                return (
                                  <>
                                    <span key={i}>{k}</span>
                                    <br></br>
                                  </>
                                );
                              })}
                            </td>
                          ) : (
                            <td>{formfield[key]}</td>
                          )}
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            </div>
             <div className="patient-consultation-layout mt-3">
            <div className="table-heading position-relative mb-5">
              <h5 className="mb-0">Pharmacy Information</h5>
              <div className="heading-underline"></div>
            </div>
            <div className="table-responsive">
              <Table striped className="consultation-table mb-4">
                <tbody>
                  <tr>
                    <th> PHARMACY NAME</th>
                    <td>{consultationData?.pharmacyName}</td>
                  </tr>
                  <tr>
                    <th>PHARMACY PHONE</th>
                    <td>{consultationData?.pharmacyPhone}</td>
                  </tr>
                  <tr>
                    <th>PHARMACY ADDRESS</th>
                    <td>{consultationData?.pharmacyAddress}</td>
                  </tr>
                  <tr>
                    <th>PHARMACY CITY</th>
                    <td>{consultationData?.pharmacyCity}</td>
                  </tr>
                  <tr>
                    <th>PHARMACY STATE</th>
                    <td>{consultationData?.pharmacyState?.title}</td>
                  </tr>
                  <tr>
                    <th>PHARMACY Zip Code</th>
                    <td>{consultationData?.pharmacyZip}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
            </div>

            {consultationData?.updatedPharmacy ? (
              <>
                <div className="patient-consultation-layout mt-3">
                <div className="table-heading position-relative mb-5">
                  <h5 className="mb-0">Updated Pharmacy Information</h5>
                  <div className="heading-underline"></div>
                </div>
                <div className="table-responsive">
                  <Table striped className="consultation-table mb-4">
                    <tbody>
                      <tr>
                        <th> PHARMACY NAME</th>
                        <td>
                          {consultationData?.updatedPharmacy?.pharmacyName}
                        </td>
                      </tr>
                      <tr>
                        <th>PHARMACY PHONE</th>
                        <td>
                          {consultationData?.updatedPharmacy?.pharmacyPhone}
                        </td>
                      </tr>
                      <tr>
                        <th>PHARMACY ADDRESS</th>
                        <td>
                          {consultationData?.updatedPharmacy?.pharmacyAddress}
                        </td>
                      </tr>
                      <tr>
                        <th>PHARMACY CITY</th>
                        <td>
                          {consultationData?.updatedPharmacy?.pharmacyCity}
                        </td>
                      </tr>
                      <tr>
                        <th>PHARMACY STATE</th>
                        <td>
                          {consultationData?.updatedPharmacy?.state?.title}
                        </td>
                      </tr>
                      <tr>
                        <th>PHARMACY Zip Code</th>
                        <td>
                          {consultationData?.updatedPharmacy?.pharmacyZip}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                </div>
              </>
            ) : (
              <div className="table-heading position-relative mb-5">
                <h5 className="mb-0">Updated Pharmacy Information Not Found</h5>
                <div className="heading-underline"></div>
              </div>
            )}

            <div className="table-heading position-relative mb-5">
              <h5 className="mb-0">
                {consultationData?.images?.length > 0
                  ? "Attachment found"
                  : "No Attachments found"}
              </h5>
              <div className="heading-underline"></div>
            </div>

            {consultationData?.images?.map((image, index) => {
              const imageUrl = setFilePath(image?.photo);
              return (
                <>
                  <img
                    key={index}
                    onClick={() => downloadImage(imageUrl)}
                    src={imageUrl}
                    className="mr-5 mb-2"
                    crossOrigin="anonymous"
                    width="200"
                    height="200"
                    alt="not found"
                  />
                </>
              );
            })}

            <div className="d-flex justify-content-end">
              {!consultationData.prescription || consultationData.noPrescription  ? <button
                type="button"
                className="btn-filled d-flex align-items-center btn btn-primary mr-2"
                onClick={handleShowNotsent}
              >
              No Prescription
              </button>:""}
              <button
                type="button"
                className="btn-filled d-flex align-items-center btn btn-primary"
                onClick={handleShow}
              >
                {consultationData?.prescription && !consultationData.noPrescription
                  ? "Update Prescription"
                  : "Send Prescription"}{" "}
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
